import React, { CSSProperties, useState } from 'react'
import { Avatar, List, Row, Typography, Col } from 'antd'
import { useTranslation } from 'react-i18next'

import { ButtonTitled, Empty } from 'src/components/Ant'
import { Request, RequestStandardSharing } from 'src/types'

import ModalForm from '../ModalForm'

import * as CSS from './styles'

interface Props {
  bodyStyle?: CSSProperties
  enableModal?: boolean
  handleDelete?(item: RequestStandardSharing): void
  handleEdit?(item: RequestStandardSharing): void
  incompleteSharing?: boolean
  request: Request
  restPercentage?: number
}

function SharingSummary({
  bodyStyle = {},
  enableModal = false,
  handleDelete,
  handleEdit,
  incompleteSharing = false,
  request,
  restPercentage
}: Props) {
  const { t } = useTranslation()

  const [visibleModal, setVisibleModal] = useState<boolean>(false)

  return (
    <>
      {enableModal && (
        <ModalForm
          request={request}
          toggle={() => {
            setVisibleModal(false)
          }}
          visible={visibleModal}
        />
      )}
      <CSS.WrapCard
        bodyStyle={bodyStyle}
        data-test-id="summary-sharings"
        extra={[
          ...(enableModal
            ? [
                <ButtonTitled
                  key="edit-itinerary"
                  icon="edit"
                  onClick={() => setVisibleModal(true)}
                  size="default"
                  tooltip="common.actions.edit"
                />
              ]
            : [])
        ]}
        title="web.assignment.sharing.list-title"
      >
        <List
          data-test-id="sharings-list"
          dataSource={request.request_standard_assignments.request_standard_sharings.filter(
            ({ active }: RequestStandardSharing) => active
          )}
          header={
            restPercentage >= 0 && (
              <CSS.WrapProgress
                data-test-id="sharings-bar"
                percent={100 - restPercentage}
                size="small"
                status={incompleteSharing ? 'exception' : null}
              />
            )
          }
          itemLayout="horizontal"
          locale={{ emptyText: <Empty onlyText /> }}
          renderItem={(item: RequestStandardSharing, index: number) => (
            <List.Item
              actions={[
                ...(handleEdit
                  ? [
                      <ButtonTitled
                        icon="edit"
                        onClick={() => handleEdit(item)}
                        shape="circle"
                        tooltip="common.actions.edit"
                      />
                    ]
                  : []),
                ...(handleDelete
                  ? [
                      <ButtonTitled
                        icon="delete"
                        onClick={() => handleDelete(item)}
                        shape="circle"
                        tooltip="common.actions.remove"
                        type="danger"
                      />
                    ]
                  : [])
              ]}
              data-test-id={`sharings-item-${index}`}
            >
              <List.Item.Meta
                avatar={
                  <Avatar size="large" style={{ backgroundColor: '#1890ff' }}>
                    {item.percentage}%
                  </Avatar>
                }
                description={
                  <>
                    <Row>
                      <Col>
                        <Typography.Text strong>
                          {`${t(
                            'web.assignment.sharing.form.cost-center.title'
                          )}: `}
                        </Typography.Text>
                        {!item.cost_center.code
                          ? ''
                          : `${item.cost_center.code} - `}
                        {item.cost_center.name}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Typography.Text strong>
                          {`${t(
                            'web.assignment.sharing.form.contract.title'
                          )}: `}
                        </Typography.Text>
                        {!item.contract.code ? '' : `${item.contract.code} - `}
                        {item.contract.name}
                      </Col>
                    </Row>
                  </>
                }
              />
            </List.Item>
          )}
        />
      </CSS.WrapCard>
    </>
  )
}

export default SharingSummary
